var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestsellers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13457_10076)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#002069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5489 25.9271C48.8483 25.0057 50.1517 25.0057 50.4511 25.9271L55.4496 41.3111C55.5835 41.7231 55.9674 42.002 56.4007 42.002H72.5764C73.5451 42.002 73.9479 43.2416 73.1642 43.8111L60.0777 53.3189C59.7273 53.5735 59.5806 54.0249 59.7145 54.4369L64.713 69.8209C65.0124 70.7422 63.9579 71.5084 63.1742 70.9389L50.0878 61.4311C49.7373 61.1765 49.2627 61.1765 48.9122 61.4311L35.8258 70.9389C35.0421 71.5084 33.9876 70.7422 34.287 69.8209L39.2855 54.4369C39.4194 54.0249 39.2727 53.5735 38.9223 53.3189L25.8358 43.8111C25.0521 43.2416 25.4549 42.002 26.4236 42.002H42.5993C43.0325 42.002 43.4165 41.7231 43.5504 41.3111L48.5489 25.9271Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13457_10076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestsellers);
export default __webpack_public_path__ + "static/media/bestsellers.81f8515d258dc2c5fb6dd7632e8c5eba.svg";
export { ForwardRef as ReactComponent };